import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import { useSeo } from "@/hooks/useSeo";

export default function Services() {
  useSeo("Our Services | Roof, Render, Driveway, Gutter & Fascia Cleaning | StoneCrest", "Explore StoneCrest's premium exterior cleaning services for residential and commercial properties across Lancashire: roof cleaning, render softwashing, driveway & patio cleaning, gutter clearing and fascia & soffit cleaning.", "https://stonecrestexteriors.co.uk/services");
  return (
    <div>
      <PageHeader overline="Our Services" lines={["Specialist exterior", "cleaning services."]} subtitle="Five dedicated specialisms for residential and commercial properties, each carried out with premium equipment, safe methods and meticulous care." />
      <section className="px-6 md:px-12 max-w-7xl mx-auto pb-24 md:pb-32">
        <div className="space-y-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={0.04}>
              <Link to={`/services/${s.slug}`} data-testid={`services-list-${s.slug}`} className="group grid md:grid-cols-12 gap-0 border border-[var(--border)] overflow-hidden hover:border-[var(--oxblood)] transition-colors duration-500">
                <div className={`md:col-span-5 relative aspect-[16/10] md:aspect-auto overflow-hidden ${i % 2 ? "md:order-2" : ""}`}>
                  <img src={s.image} alt={s.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="md:col-span-7 p-8 md:p-12 flex flex-col justify-center">
                  <span className="font-display text-sm text-[var(--oxblood)]">{String(i + 1).padStart(2, "0")}</span>
                  <h2 className="font-serif text-3xl md:text-4xl mt-2 mb-3 group-hover:text-[var(--oxblood)] transition-colors">{s.name}</h2>
                  <p className="text-[var(--muted)] leading-relaxed max-w-xl">{s.description.slice(0, 160)}…</p>
                  <span className="mt-6 text-xs uppercase tracking-[0.2em] flex items-center gap-2 text-[var(--oxblood)]">View service <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CTASection />
    </div>
  );
}
